// extracted by mini-css-extract-plugin
module.exports = {"resumeFiltersTitle":"ResumeFiltersDialog_resumeFiltersTitle_2RnrU","formActions":"ResumeFiltersDialog_formActions_1QZ10"};